export default __webpack_public_path__ + "static/media/lipstick3.923e4fc5.jpg";